import { render, staticRenderFns } from "./editorFile.vue?vue&type=template&id=0282ad86"
import script from "./editorFile.vue?vue&type=script&lang=js"
export * from "./editorFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports